import React, { useEffect, useRef } from "react"

import SpCard from "./SpCard"
import { getSubscriptionPlans } from "services"
import { PageLoader } from "components"
import classes from "./SpPlans.module.scss"

const SpPlans = (props) => {
  const {
    setPage,
    setSelectedPlan,
    subscriptionPlans,
    setSubscriptionPlans,
    currentContractSubscriptionPlan
  } = props

  const unmount = useRef(false)

  const getAllSubscriptionPlans = async () => {
    if (subscriptionPlans !== null) return

    try {
      const response =
        await getSubscriptionPlans()

      if (unmount.current) return

      const plansMap = {}

      response.forEach(plan => {
        const planName = plan.name

        plansMap[planName] =
          !!plansMap[planName]
            ? [...plansMap[planName], { ...plan }]
            : [{ ...plan }]
      })

      setSubscriptionPlans(plansMap)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    unmount.current = false

    getAllSubscriptionPlans()

    return () => {
      unmount.current = true
    }
  }, [])

  if (subscriptionPlans === null) return <PageLoader />

  const planNames =
    Object.keys(subscriptionPlans)

  return (
    <div className={classes["plans"]}>
      {planNames.map(planName => (
        <div
          key={planName}
          className={classes["product"]}
          xs={12} sm={6} md={4} lg={4} xl={3}
        >
          <SpCard
            setPage={setPage}
            planName={planName}
            setSelectedPlan={setSelectedPlan}
            subscriptionPlans={subscriptionPlans[planName]}
            currentContractSubscriptionPlan={currentContractSubscriptionPlan}
          />
        </div>
      ))}
    </div>
  )
}

export default SpPlans